module.exports = __webpack_public_path__ + "static/media/Starfish1_light.7ef16699.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/Services/Starfish1_light.svg
// module id = 124
// module chunks = 0